import styled from 'styled-components';
import { DND_GRID_GAP, ENTIRE_GRID_DROPPABLE_ID } from './constants';
import React, { PropsWithChildren } from 'react';
import { useDroppable } from '@dnd-kit/core';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${DND_GRID_GAP}px;
`;

/**
 * This wrapper is rather a hack to allow autoscrolling when dragging. It looks like dndkit only scorolls if the
 * current draggable is over a droppable area. No biggie - we just define the entire grid as a droppable
 * and we ignore the collisions with it
 *
 * @param children
 */

export const DndGridWrapper = ({ children }: PropsWithChildren<object>) => {
  const { setNodeRef } = useDroppable({ id: ENTIRE_GRID_DROPPABLE_ID });
  return <Wrapper ref={setNodeRef}>{children}</Wrapper>;
};
